import withAuth from "./../../common/helper/auth-component.js";
import { connect } from "react-redux";
import DataTable from "react-data-table-component";
import React, { useState, useEffect } from "react";
import DashboardService from "../../../services/dashboard-service.js";
import LoaderOverlay from "./../../common/helper/loader.component.js";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import StatusBadge from "../../common/helper/transaction-status.component.js";
import {
  transactionSerachFormData,
} from "../../common/helper/form-constants.js";
import { MESSAGES } from "../../constants/constants.js";
import MUIButton from "../../common/miui-component/mui-button.jsx";
import FilterListIcon from "@mui/icons-material/FilterList";
import SearchFilter from "./../../common/helper/searchFilter.js";
import {
  RowsPerPageSelector,
  customDataTableStyles,
} from "./../../common/helper/table-imports.js";

const Transactions = () => {
  const dispatch = useDispatch();
  const [role, setUserRole] = useState("");
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);
  const [transaction, setTransactionData] = useState();
  const [dataTableKey, setDataTableKey] = useState(0);
  const navigate = useNavigate();
  const userData = useSelector((state) => state.authReducer);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [pageNo, setPageNo] = useState(0);
  const [totalRows, setTotalRows] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [isOpenDrawer, setIsOpenDrawer] = React.useState(false);
  const [formData, setFormData] = useState({ ...transactionSerachFormData, from_date: '', to_date: '' });

  const paginationComponentOptions = {
    noRowsPerPage: true,
  };

  const [columns, setColumns] = useState([
    {
      name: "Order ID",
      cell: (row) => (
        <div className="custom-cell-order_Code">
          <a
            href="javascript:void(0)"
            onClick={() => viewTransaction(row.transaction_id)}
          >
            {row.order_code}
          </a>
        </div>
      ),
      sortable: true,
    },
    {
      name: "Payment Type",
      selector: (row) => (
        <>
          <div
            style={{
              color:
                row.transaction_type.toLowerCase() === "payin"
                  ? "green"
                  : "red",
            }}
          >
            <i
              className="fa fa-money me-1"
              style={{
                color:
                  row.transaction_type.toLowerCase() === "payin"
                    ? "green"
                    : "red",
              }}
            />
            {row.transaction_type.toLowerCase().charAt(0).toUpperCase() +
              row.transaction_type.toLowerCase().slice(1)}
          </div>
        </>
      ),
      sortable: true,
    },
    {
      name: "Date",
      selector: (row) => (
        <div className="custom-cell-order_Code">{row.start_date}</div>
      ),
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) => (
        <>
          <StatusBadge status={row.status} />
        </>
      ),
      sortable: true,
    },
    {
      name: "Amount",
      selector: (row) => "₹" + row.amount,
      sortable: true,
    },
    {
      name: "Payment Method",
      selector: (row) => (
        <>
          <i
            className={`fa  me-1 ${
              row.payment_method && row.payment_method.toLowerCase() === "imps"
                ? "fa-money"
                : row.payment_method &&
                  row.payment_method.toLowerCase() === "wallet"
                ? "fa-credit-card"
                : row.payment_method &&
                  row.payment_method.toLowerCase() === "upi"
                ? "fa-google-wallet"
                : row.payment_method &&
                  row.payment_method.toLowerCase() === "qr"
                ? "fa-qrcode "
                : ""
            }`}
          />{" "}
          {row.payment_method || "-"}
        </>
      ),
      sortable: true,
    },
    {
      name: "Actions",
      selector: (row) => (
        <>
          <div style={{ display: "flex" }}>
            <a
              className="fview tooltip"
              style={{ cursor: "pointer" }}
              onClick={() => {
                viewTransaction(row.transaction_id);
              }}
            >
              <i className="fa fa-eye" />
              <span className="tooltiptext">View</span>
            </a>
            {row.status == "P" && (
              <>
                <a
                  className="tooltip dropdown-toggle"
                  href="#"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i
                    className="fa fa-ellipsis-v"
                    aria-hidden="true"
                    style={{ color: "black" }}
                  />
                  <span className="tooltiptext">More</span>
                </a>
                <ul
                  className="dropdown-menu transaction dropdown-menu-end mbv"
                  id="nvb"
                  aria-labelledby="navbarDropdown"
                >
                  <li
                    onClick={() => {
                      confirm(row.transaction_id, row.order_code);
                    }}
                  >
                    <a
                      className="dropdown-item"
                      style={{ cursor: "pointer", fontSize: "13px" }}
                    >
                      Confirm
                    </a>
                  </li>
                  <li
                    onClick={() => {
                      raised(row.transaction_id, row.order_code);
                    }}
                  >
                    <a
                      className="dropdown-item"
                      style={{ cursor: "pointer", fontSize: "13px" }}
                    >
                      Raised
                    </a>
                  </li>
                </ul>
              </>
            )}
          </div>
        </>
      ),
    },
  ]);

  const viewTransaction = (id) => {
    navigate(`/transaction/${id}`);
  };

  const confirm = (id, orderCode) => {
    navigate(`/confirm-transaction/${id}/${orderCode}}`);
  };

  const raised = (id, orderCode) => {
    navigate(`/raised-transaction/${id}/${orderCode}`);
  };

  const listTransactions = (fiterReset = false, pageNumber, rowsPage, filterData, txStatus) => {
    setStatus(txStatus);
    setLoading(true);
    DashboardService.getTransactionsList(
      fiterReset ? {} : filterData,
      pageNumber,
      rowsPage,
      txStatus
    )
      .then((response) => {
        const records = response.data.data.list;
        setTotalRows(response.data.data.total_records);
        setTransactionData(records);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        try {
          const errorMessage = error.response.data;
          toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR);
        } catch (e) {
          toast.error(MESSAGES.SERVER_ERROR);
        }
      });
  };

  const viewAgent = (row) => {
    let id = row.sender_id;
    if (row.transaction_type == "PAYIN") {
      id = row.receiver_id;
    }
    navigate("/view-agent/" + id);
  };

  const applyFilter = (data) => {
    setFormData(data);
    listTransactions(false, pageNo, rowsPerPage, data, status);
    setIsOpenDrawer(false);
  };

  useEffect(() => {
    let userRole;
    if (userData && userData.user && userData.user.data) {
      userRole = userData.user.data.role.role_code;
      setUserRole(userRole);
    }

    if (userRole === "ADMIN") {
      const updatedColumns = [
        ...columns.slice(0, 4),
        ...[
          {
            name: "Merchant",
            cell: (row) => (
              <div className="custom-cell-order_Code">
                {row.transaction_type == "PAYIN"
                  ? row.sender_name
                  : row.receiver_name}
              </div>
            ),
            sortable: true,
          },
          {
            name: "Distributor",
            cell: (row) => (
              <div className="custom-cell-order_Code">
                {row.distributor_name || "-"}
              </div>
            ),
            sortable: true,
          },
          {
            name: "Agent",
            cell: (row) => (
              <div className="custom-cell-order_Code">
                {row.transaction_type == "PAYIN"
                  ? row.receiver_name
                  : row.sender_name}
              </div>
            ),
            sortable: true,
          },
          {
            name: "Agent Code",
            cell: (row) => (
              <div className="custom-cell-order_Code">
                {row.agent_code && row.agent_code.trim() !== "-" ? (
                  <a href="javascript:void(0)" onClick={() => viewAgent(row)}>
                    {row.agent_code}
                  </a>
                ) : (
                  "-"
                )}
              </div>
            ),
            sortable: true,
          },
        ],
        ...columns.slice(4),
      ];
      setColumns(updatedColumns);
    }

    listTransactions(false, 0, 25, formData, userRole !== "ADMIN" ? "P" : "");

    document.body.style.backgroundImage = "";
    document.body.style.backgroundColor = "#f0f6fa";
    return () => {
      document.body.style.backgroundColor = "";
    };
  }, []);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const escapeRegExp = (string) => {
    return string.replace(/[.*+\-?^${}()|[\]\\]/g, "\\$&");
  };

  function getStatusText(statusCode) {
    switch (statusCode) {
      case "I": return "Initiated";
      case "A": return "Completed";
      case "AA": return "Agent Accepted";
      case "RA": return "Raised";
      case "RM": return "Merchnat Raised";
      case "F": return "Failed";
      case "R": return "Rejected";
      case "MC": return "Cancelled";
      case "E": return "Expired";
      default: return "";
    }
  }

  const filteredData =
    transaction &&
    transaction.filter((row) => {
      return Object.values(row).some((value) => {
        if (value === row.status) {
          const statusText = getStatusText(row.status);
          return statusText.toLowerCase().includes(searchTerm.toLowerCase());
        }
        return new RegExp(escapeRegExp(searchTerm), "i").test(value);
      });
    });

  const handleRowsPerPageChange = (value) => {
    let rowsPage = Number(value);
    setRowsPerPage(rowsPage);
    setDataTableKey((prevKey) => prevKey + 1);
    listTransactions(false, pageNo, rowsPage, formData, status);
  };

  const handlePageChange = (page) => {
    let pageNumber = page - 1;
    setPageNo(pageNumber);
    listTransactions(false, pageNumber, rowsPerPage, formData, status);
  };

  return (
    <>
      <LoaderOverlay loading={loading} />

      <div className="container-fluid px-4" style={{ paddingBottom: "30px" }}>
        <div className="d-flex justify-content-between mb-3">
          <h4
            className="mb-0 updatename updatename1 align-self-center text-color-theme"
            style={{ marginTop: 0, fontWeight: 700, fontSize: "22px" }}
          >
            Transaction History
          </h4>
          <div>
            <MUIButton
              btnOnClick={() => setIsOpenDrawer(true)}
              btnLabel="Filter"
              btnStyle={{
                backgroundColor: "#ffffff",
                color: "black",
                borderRadius: "10px",
                "&:hover": {
                  backgroundColor: "rgb(117 121 124 / 82%)",
                },
              }}
            >
              <FilterListIcon sx={{ fontSize: "25px", marginLeft: "6px" }} />
            </MUIButton>
          </div>
        </div>

        <div className="container" style={{ backgroundColor: "white" }}>
          <nav>
            <div className="nav nav-tabs" id="nav-tab" role="tablist">
              <button
                className="nav-link tbbtn active"
                id="nav-home-tab"
                data-bs-toggle="tab"
                data-bs-target="#nav-home"
                type="button"
                role="tab"
                aria-controls="nav-home"
                aria-selected="true"
              >
                Transactions
              </button>
            </div>
          </nav>

          <div className="filterBtn">
            <div id="examplemgm_filter" className="dataTables_filter">
              <label>
                <input
                  type="search"
                  placeholder="Search..."
                  value={searchTerm}
                  onChange={handleSearchChange}
                  aria-controls="examplemgm"
                />
              </label>
            </div>
          </div>

          <RowsPerPageSelector
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleRowsPerPageChange}
          />

          <div
            className="tab-content"
            id="nav-tabContent"
            style={{ paddingTop: "15px", paddingBottom: "15px" }}
          >
            <div
              className="tab-pane fade active show"
              id="nav-home"
              role="tabpanel"
              aria-labelledby="nav-home-tab"
            >
              <div
                id="examplemgmwallet_wrapper"
                className="dataTables_wrapper dt-jqueryui no-footer"
              >
                <DataTable
                  key={dataTableKey}
                  columns={columns}
                  data={filteredData}
                  pagination
                  paginationComponentOptions={paginationComponentOptions}
                  paginationPerPage={rowsPerPage}
                  paginationServer
                  paginationTotalRows={totalRows}
                  onChangePage={handlePageChange}
                  customStyles={customDataTableStyles}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <SearchFilter
        isOpenDrawer={isOpenDrawer}
        setIsOpenDrawer={setIsOpenDrawer}
        fetchTransaction={(data) => applyFilter(data)}
        formData={formData}
        setFormData={setFormData}
        module="Transaction"
        isTransactionFilter={true}
      />
    </>
  );
};

function mapStateToProps(state) {
  const userData = state.authReducer.user;
  return { userData };
}
export default withAuth(connect(mapStateToProps)(Transactions));
